import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InfoIcon from '@mui/icons-material/Info';
import { general } from '../../config.json'
import { config } from "../../Services/config.service"
import logoLightMode from '../../Images/waldmonitor_Mono Dunkel.png';
import logoDarkMode from '../../Images/waldmonitor_Mono Hell.png';
import { createTheme, useTheme } from '@mui/material/styles';
import ShareIcon from '@mui/icons-material/Share';

import { Grid } from '@mui/material';


export default function NavbarCustom(props: any) {
    const theme = useTheme();

    const handleShareClick= () =>{
        props.setLeftSubDrawerOpen(true)
        props.setLeftSubDrawerType("TEILEN")

    }
    


    return (<>
        {props.mobile ?
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="static">
                    <Toolbar>
                        <Grid
                            justifyContent="space-between"
                            container
                        // spacing={24}
                        >
                            <Grid item xs={2}>
                                <IconButton
                                    size="large"
                                    edge="start"
                                    color="inherit"
                                    aria-label="menu"
                                    // sx={{ mr: 2 }}
                                    onClick={() => props.setLeftMainDrawerOpen(true)}
                                >
                                    <MenuIcon />
                                </IconButton>
                            </Grid>

                            <Grid item container xs={6}>
                                <Grid item container alignItems="center">

                                    <Box
                                        component="img"
                                        sx={{
                                            m: 1,
                                            maxWidth: "50vw"
                                        }}
                                        src={theme.palette.mode == "light" ? logoLightMode : logoDarkMode}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={4}>
                                <Grid item container justifyContent="flex-end">

                                    <IconButton
                                        // color="primary"
                                        color="inherit"
                                        size="large"

                                        aria-label="share"
                                    // variant="contained"
                                    onClick={() => handleShareClick()}
                                    >
                                        <ShareIcon />

                                    </IconButton>

                                </Grid>

                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
            </Box>
            :
            // <Box sx={{ flexGrow: 1 }}>

            <AppBar
                style={{ flex: 1 }}
                // position='absolute'
                sx={{
                    width: config.general["leftDrawerWidthDesktop"],//`${props.drawerWidth}px`,
                    mr: `calc(100% - ${config.general["leftDrawerWidthDesktop"]})`
                }}>

                <Toolbar>
                    <Grid
                        justifyContent="center"
                        alignItems="center"
                        container
                    // spacing={24}
                    >
                    <Box
                        component="img"
                        sx={{
                            mt: 1,
                            width: config.general["logoWidthDesktop"]
                        }}
                        src={theme.palette.mode == "light" ? logoLightMode : logoDarkMode}
                    />
                    </Grid>
                </Toolbar>
            </AppBar>
            // </Box>
        }
    </>
    );
}



